

<div class="error-wrapper">
  <div class="error-container">
    <img alt="spearad-error">
    <div>
      <h1>Connection Error</h1>
      <p>Spearad seems to be unavailable. Please try again soon.</p>
      <button class="primary-button" [routerLink]="'/portal'" nz-button nzType="primary" id="go-to-unruly">Go to Nexxen</button>
      <button class="secondary-button margin-left-1" (click)="location.reload()" nz-button id="reload">Refresh</button>
    </div>
  </div>
</div>
